var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeparatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19934 14.0001C7.09421 14.003 6.9897 13.9836 6.89304 13.9433C6.79638 13.903 6.70986 13.8428 6.63948 13.7668L0.239665 7.54422C0.0943794 7.3971 0.00907709 7.20364 -0.000339084 6.9999C-0.00325321 6.89769 0.0166987 6.79608 0.0581372 6.7021C0.0995758 6.60812 0.161512 6.52401 0.239665 6.45559L6.63948 0.233461C6.71171 0.159691 6.7986 0.100958 6.89487 0.060826C6.99115 0.020694 7.09482 0 7.19957 0C7.30432 0 7.40799 0.020694 7.50427 0.060826C7.60054 0.100958 7.68743 0.159691 7.75966 0.233461C7.83553 0.303679 7.89594 0.388155 7.93722 0.48176C7.9785 0.575366 7.99978 0.67615 7.99978 0.777996C7.99978 0.879842 7.9785 0.980626 7.93722 1.07423C7.89594 1.16784 7.83553 1.25231 7.75966 1.32253L1.9197 6.9999L7.75921 12.676C7.83508 12.7462 7.89549 12.8306 7.93677 12.9243C7.97805 13.0179 7.99933 13.1186 7.99933 13.2205C7.99933 13.3223 7.97805 13.4231 7.93677 13.5167C7.89549 13.6103 7.83508 13.6948 7.75921 13.765C7.68899 13.8413 7.60256 13.9019 7.50588 13.9425C7.40921 13.9831 7.30461 14.0027 7.19934 14.0001Z",
    fill: "#121212",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorIcon);
export default __webpack_public_path__ + "static/media/SeparatorIcon.277ed155.svg";
export { ForwardRef as ReactComponent };